import { useContext } from "react";
import { PilotAssignmentStoreContext } from "../context/PilotAssignmentStoreContext";
import { StoreApi } from "zustand";
import { IPilotAssignmentStore } from "../stores/PilotAssignmentStore";

export function usePilotAssignmentStoreContext(): StoreApi<IPilotAssignmentStore> {
    return useContext(PilotAssignmentStoreContext);
}
